export default {
  path: '/leader',
  name: 'Leader',
  redirect: '/leader/list',
  component: () => import('@/components/layout'),
  meta: { requiresAuth: true },
  children: [
    {
      path: 'list',
      component: () => import('@/views/leader'),
      meta: { requiresAuth: true }
    },
    {
      path: 'info',
      component: () => import('@/views/leader/Info'),
      meta: { requiresAuth: true }
    }
  ]
}
